import { Service, inject } from '@angular/core';
import { TranslateService, TranslationObject } from '@ngx-translate/core';

export interface Locale {
    lang: string;
    data: Object;
}

@Service()
export class FuseTranslationLoaderService {
    private _translateService = inject(TranslateService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    /**
     * Constructor
     *
     * @param {TranslateService} _translateService
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Load translations
     *
     * @param {Locale} args
     */
    loadTranslations(...args: Locale[]): void {
        const locales = [...args];

        locales.forEach((locale) => {
            // use setTranslation() with the third argument set to true
            // to append translations instead of replacing them
            this._translateService.setTranslation(locale.lang, locale.data as TranslationObject, true);
        });
    }
}
